import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Home from '../Home';
import LabInventory from '../Inventory/Labs';
import InventoryV2 from '../InventoryV2';
import OrdersV2 from '../OrdersV2';
import OrderDetails from '../Orders/OrderDetails';
import SettingsV2 from '../SettingsV2';
import DSOPricing from '../DSOPricing';
import AiSkuMapping from '../AiSkuMapping';

import { MenuIcon } from './Styles/Icons';
import { RootCard, BodyContainer, TopBar, DentiraLogo, IconButton, Hidden, FlexRow, NotFound, Button } from './Styles/Body';

import { toggleDrawer } from '../../actions/toggleDrawer';
import { history, checkLabSeller } from '../../commons/utils';
import { setBaseUrlDependingOnUserTypes } from '../../actions/commonActions';

const NoMatch = () => (
	<FlexRow style={{ marginTop: '8rem', justifyContent: 'center' }}>
		<NotFound
			lines={[
				'404 Not Found',
				<Button
					primary
					onClick={(e) => history.push('/')}
				>
					Home
				</Button>,
			]}
		/>
	</FlexRow>
);

const DentalRoutes = [
	{
		path: '/',
		component: Home,
	},
	{
		path: '/inventoryV2',
		component: InventoryV2,
	},
	{
		path: '/ordersV2',
		component: OrdersV2,
	},
	{
		path: '/order/details',
		component: OrderDetails,
	},
	{
		path: '/settingsV2',
		component: SettingsV2,
	},
	{
		path: '/dsopricing',
		component: DSOPricing,
	},
];

const LabRoutes = [
	{
		path: '/',
		component: LabInventory,
	},
	{
		path: '/dsopricing',
		component: DSOPricing,
	},
	{
		path: '/aiSkuMapping',
		component: AiSkuMapping
	}
];

class Body extends React.Component {
	componentDidMount() {
		let { userTypes } = this.props;

		setBaseUrlDependingOnUserTypes(userTypes);
	}

	openSideDrawer(event) {
		this.props.toggleDrawer(true);
	}

	render() {
		let { isLabSeller } = this.props;
		let routes = DentalRoutes;
		if (isLabSeller) {
			routes = LabRoutes;
		}

		return (
			<BodyContainer>
				<TopBar>
					<DentiraLogo />

					<Hidden lgUp>
						<IconButton
							aria-label='menu'
							onClick={(e) => this.openSideDrawer(e)}
						>
							<MenuIcon />
						</IconButton>
					</Hidden>
				</TopBar>

				<RootCard>
					<Switch>
						{routes.map((route, index) => (
							<Route
								key={index}
								exact
								path={route.path}
								component={route.component}
							/>
						))}
						<Route component={NoMatch} />
					</Switch>
				</RootCard>
			</BodyContainer>
		);
	}
}

const mapStatesToProps = (state) => {
	return {
		userTypes: state?.session?.user_type,
		isLabSeller: checkLabSeller(state?.session?.user_type),
	};
};

export default connect(mapStatesToProps, { toggleDrawer })(Body);
